import { API_URL } from '../../config';
import { getLoginToken } from '../../helpers/sessionHandler';
import axios from 'axios';

export const GET_INVOICES = 'GET_INVOICES'
export const FLUSH_INVOICES = 'FLUSH_INVOICES'

export const ReceiveInvoices = (invoices) => ({
  type: GET_INVOICES,
  invoices: invoices
})

export const FetchInvoices = () => async (dispatch) => {

  let options = {
    method: 'GET',
    headers: {'Authorization': "Bearer " + getLoginToken()}
  }

  fetch(API_URL+'/invoices', options)
    .then(response => response.json())
    .then(invoices => dispatch(ReceiveInvoices(invoices)))
    .catch(error => {
      throw(error)
    })
}

export const DownloadInvoice = (id) => async () => {
  var config = {
    headers: {'Authorization': "Bearer " + getLoginToken()},
    responseType: 'blob'
  }

  axios.get(API_URL+`/index.php?a=fpdf&id=` + id, config)
    .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'faktura.pdf');
    document.body.appendChild(link);
    link.click();
  });
}





// WEBPACK FOOTER //
// ./src/store/invoices/actions.js